import { Fragment } from "react/jsx-runtime";
import Table from "./Table/";
import PreFilters from "./PreFilters";
import { useEffect, useId, useState } from "react";
import { getCurrentEasternYear } from "../../util/functions";
import { SESSION_KINDS } from "../../util/constants";
import { Mui } from "@osu/react-ui";
import { useSelector } from "react-redux";
import { selectActiveReportingPeriod } from "../../services/submissionPeriod/slices";

const CURRENT_YEAR = getCurrentEasternYear();

function Submissions() {
  const id = useId()
  const headingId = id + "-heading";
  const defaultYear = useSelector(state => selectActiveReportingPeriod(state)?.year || CURRENT_YEAR);
  const [filters, setFilters] = useState({
    year: defaultYear, 
    type: SESSION_KINDS.FGC
  })
  const { year, type } = filters || {}

  useEffect(() => {
    setFilters(existing => ({
      ...existing,
      year: defaultYear
    }))
  }, [defaultYear])

  return (
    <Fragment>
      <Mui.Typography component="h2" variant="h2" id={headingId} sx={{ mb: 2 }}>
        {year} Forms
      </Mui.Typography>
      <PreFilters defaultYear={defaultYear} onClick={({ year: _year, type: _type }) => {
        setFilters(existing => {
          let newFilters = { ...existing }
          if(_year) {
            newFilters.year = _year
          }
          if(_type) {
            newFilters.type = _type
          }
          return newFilters
        })
      }}/>
      <Table aria-labelledby={headingId} id={id + "-table"} year={year} type={type} />
    </Fragment>
  );
}

export default Submissions;
